module.exports = __webpack_public_path__ + "static/13-177ccb67f7b9455d32497bb27da14b6a.jpg";